import { render, staticRenderFns } from "./DashBoxVelocityTable.vue?vue&type=template&id=7d5a19e4&"
import script from "./DashBoxVelocityTable.vue?vue&type=script&lang=js&"
export * from "./DashBoxVelocityTable.vue?vue&type=script&lang=js&"
import style0 from "./DashBoxVelocityTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports